import { render } from "./HalamanDetailBerita.vue?vue&type=template&id=07af526c"
import script from "./HalamanDetailBerita.vue?vue&type=script&lang=js"
export * from "./HalamanDetailBerita.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__